namespace $.$$ {
	
	$mol_style_define( $giper_baza_land_rights, {
		
		gap: $mol_gap.block,
		
		Gift: {
			flex: {
				wrap: 'wrap',
			},
			background: {
				color: $mol_theme.card,
			},
		},
		
		Gift_name: {
			flex: {
				grow: 1,
			},
		},
		
		Gift_tier: {
			flex: {
				grow: 0,
				basis: `7em`,
			},
			font: {
				family: 'monospace',
			},
		},
		
		Gift_rate: {
			flex: {
				grow: 0,
				basis: `8em`,
			},
		},
		
	} )
	
}
